module.exports = __webpack_public_path__ + "img/21.f110d0b2.jpg";